import { Card, CardContent } from "../ui/card";
import { X } from "lucide-react";
interface ProductCardProps {
  id: number;
  image: string;
  brand: string;
  name: string;
  price: string;
  mrpPrice: string;
  heartIcon: string;
  onFavoriteClick?: (id: number) => void;
  onProductClick?: (id: number) => void;
  removeButton?: boolean;
  onRemove?: (id: number) => void;
}
export const ProductCard = ({
  id,
  image,
  brand,
  name,
  price,
  mrpPrice,
  onProductClick,
  removeButton = false,
  onRemove,
}: ProductCardProps) => {
  const handleProductClick = () => {
    onProductClick?.(id);
  };
  const handleRemoveClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.(id);
  };
  const parsePriceToNumber = (value: string): number => {
    const numeric = value.replace(/[^0-9.]/g, "");
    const parsed = parseFloat(numeric);
    return Number.isNaN(parsed) ? 0 : parsed;
  };
  const discountPercent = (() => {
    const mrp = parsePriceToNumber(mrpPrice);
    const current = parsePriceToNumber(price);
    if (mrp <= 0 || current <= 0 || mrp <= current) return 0;
    return Math.round(((mrp - current) / mrp) * 100);
  })();
  return (
    <Card
      className="w-full border-0 shadow-none cursor-pointer transition-shadow duration-200"
      onClick={handleProductClick}
    >
      <div className="relative w-full h-[250px] overflow-hidden rounded-lg mb-3">
        <img
          className="object-cover w-full hover:scale-105 transition-transform duration-300"
          alt={name}
          src={image}
        />
        {removeButton && (
          <button
            type="button"
            onClick={handleRemoveClick}
            className="absolute top-2 right-2 z-10 bg-white/80 hover:bg-white rounded-full p-1 shadow-md transition-colors"
            aria-label="Remove"
          >
            <X className="w-4 h-4 text-gray-700" />
          </button>
        )}
      </div>
      <CardContent className="p-0 text-center space-y-1">
        <div className="font-semibold text-black text-sm line-clamp-1">
          {brand}
        </div>
        <div className="text-gray-600 text-[11px] line-clamp-2">
          {name}
        </div>
        <div className="flex items-center justify-center gap-2 text-sm">
          <span className="text-gray-500 line-through text-xs">{mrpPrice}</span>
          <span className="font-semibold text-black">{price}</span>
          {discountPercent > 0 && (
            <span className="text-xs text-green-900 font-medium">{discountPercent}% off</span>
          )}
        </div>
      </CardContent>
    </Card>
  );
};